import React from "react";
import styled from "styled-components";
import { Sheet, Button, useTheme } from "@mui/joy";
import { BsGithub } from "react-icons/bs";

const Hello = styled.h1`
  margin: 1% 0 1% 2%;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2.5vw" : "5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const Subtitle = styled.h2`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "1vw" : "3vw")};
  white-space: nowrap;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
`;

const JobType = styled(Subtitle)`
  border-radius: 10px;
  padding: 3%;
  background-color: ${(props) => props.theme.palette.background.level3};
  width: max-content;
  color: ${(props) => props.theme.palette.text.primary};
`;

const Headline = styled.h1`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "1.1vw" : "3.5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const NameLinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1% 5%;
`;

const ProjInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3%;
`;

const TechMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 0 auto 2% auto;
  width: 100%;
`;

const TechChildContainer = styled.img`
  display: flex;
  width: auto;
  height: auto;
  padding-top: 2%;
  max-width: 40%;
  max-height: 6vh;
  border-radius: 5%;
`;

const Description = styled.p`
  margin: 1% 5%;
  font-size: ${(props) => (props.size.width >= 800 ? "1.1vw" : "3vw")};
`;

const ExpContainer = styled.div`
  border-radius: 15;
  padding: 2;
  margin: auto;
  margin-top: 2;
  width: 100%;
  max-height: 150vh;
  display: flex;
  justify-content: space-evenly;
  flex-direction: ${(props) => (props.size.width >= 800 ? "row" : "column")};
  flex-wrap: wrap;
`;

const DescriptionContainer = styled.div`
  margin: 3% auto 3% auto;
  display: flex;
  flex-direction: column;
`;

const Project = (props) => {
  const theme = useTheme();

  const assets = props.assets;

  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const mainContainer = {
    borderRadius: 15,
    padding: 2,
    margin: "auto",
    marginTop: 2,
    width: dynamicWidth(),
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px;",
    flexDirection: "column",
  };

  const childContainer = {
    padding: "2%",
    borderRadius: "15px",
    marginTop: "3%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    width: props.size.width >= 800 ? "42%" : "90%",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
    backgroundColor: theme.palette.background.level1,
    height: "30vh",
  };

  const ProjObj = (proj, keyval) => {
    var descr = [];

    proj.description.forEach((element) => {
      descr.push(
        <Description key={element.length} size={props.size}>
          {element}
        </Description>
      );
    });

    var techs = [];
    proj.technologies.forEach((lang) => {
      techs.push(
        <TechChildContainer
          src={assets[lang.toLowerCase()]}
          alt={assets[lang.toLowerCase()]}
        key={assets[lang.toLowerCase()]}/>
      );
    });

    return (
      <Sheet sx={childContainer} key={keyval}>
        <NameLinkContainer>
          <ProjInfo>
            <Headline size={props.size}>{proj.title}</Headline>
            <JobType size={props.size} theme={theme}>
              {proj.subtitle}
            </JobType>
          </ProjInfo>
          <Button
            sx={{
              display: "flex",
              fontSize: "xx-large",
              marginRight: "5%",
            }}
            size="lg"
            variant="plain"
            onClick={(e) => {
              e.preventDefault();
              window.open(proj.link, proj.link);
            }}
          >
            <BsGithub />
          </Button>
        </NameLinkContainer>
        <DescriptionContainer>{descr}</DescriptionContainer>
        <TechMainContainer>{techs}</TechMainContainer>
      </Sheet>
    );
  };

  const projects = [];
  for (let i = 0; i < props.proj.length; i++) {
    projects.push(ProjObj(props.proj[i], i));
  }

  return (
    <div id={props.id}>
      <Sheet sx={mainContainer}>
        <Hello size={props.size}>Projects</Hello>
        <ExpContainer size={props.size}>{projects}</ExpContainer>
      </Sheet>
    </div>
  );
};

export default Project;
